var popup = document.querySelector(".bottom-popup");

if(popup){
window.addEventListener("scroll", function () {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        popup.classList.add("popped");
        return false;
    }
    else {
        popup.classList.remove("popped");
    }
})
}


// WEBPACK FOOTER //
// ./scripts/components/popup.js